<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img src="../../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Detail Workshop
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main>
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="d-flex width-100 justify-content-center mar-bottom-16">
                        <div class="animasi-card align-items-center bg-transparent d-flex mar-top-16">
                            <div class="font-16 status-login color-206CF"><span class=""><img class="mar-top-4 mar-bot-4 mar-right-4" style="width: 20px;" src="../../../assets/icons/eye-off.svg" alt=""></span> <span class="font-weight-bold color-206CF">Workshop Disembunyikan</span></div>
                        </div>
                    </div>
                    <div class="">
<!--                        <div class="d-flex width-100 justify-content-center border-bottom">-->
<!--                            -->
<!--                        </div>-->
                        <div class="">
                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEnamenonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Nama Workshop
                                    </div>
                                    <div class="nomore">
                                        {{workshopnonaktif.nama}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>
                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Nomor Telpon Workshop
                                    </div>
                                    <div class="nomore">
                                        {{workshopnonaktif.telp}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>

                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Kota Workshop
                                    </div>
                                    <div class="nomore">
                                        {{workshopnonaktif.kota}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>

                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Alamat Workshop
                                    </div>
                                    <div class="nomore">
                                        {{workshopnonaktif.alamat}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <div class="add-padding-default mar-top-16 boc-div-sticky fixed-bottom background-white">
            <div class="color-33333 font-16 line-height-21 letter-space-002 mar-bottom-24 pad-top-30">Anda tidak dapat mengubah data pada Workshop yang disembunyikan</div>
            <div class="button-lanjut ">
                <button class="btn btn-login btn-long remove-margin" id="Btnshowworkshop" @click="aktifWorkshop">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      v-if="isClicked === true"></span><span id="textBtnshowworkshop">Tampilkan Kembali Workshop ini</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailWorkshopNonaktif",
        props: ["datalistworkshop"],
        data(){
            return{
                workshopnonaktif:[],
                idworkshop:'',
                isClicked:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        mounted() {
            this.getdetailworkshopnonaktif();
        },
        methods:{
            back(){
                this.$emit('golistworkshopnonaktif')
            },

            async getdetailworkshopnonaktif() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + this.datalistworkshop.idworkshop + '&idowner=' + idowner, this.requestHeaders)
                    this.workshopnonaktif = response.data.data.workshop;
                    this.idworkshop = this.workshopnonaktif.idworkshop;
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async aktifWorkshop(){
                this.isClicked = true;
                $('#textBtnshowworkshop').hide()
                $('#Btnshowworkshop').prop('disabled', true);
                try {
                    const aktif = new FormData();
                    aktif.append('idworkshop', this.idworkshop);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/aktifkan_workshop' , aktif,this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked = false;
                        $('#textBtnshowworkshop').show()
                        $('#Btnshowworkshop').prop('disabled', false);
                        this.back()
	                    this.$toast.success(response.data.msg)
                    }else{
                        this.isClicked = false;
                        $('#textBtnshowworkshop').show()
                        $('#Btnshowworkshop').prop('disabled', false);
                        this.$toast.error(response.data.msg)
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnshowworkshop').show()
	                $('#Btnshowworkshop').prop('disabled', false);
                }
            }
        }
    }
</script>

<style scoped>
    .boc-div-sticky{
        box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.1);;
    }
</style>